/* eslint-disable */
jQuery( ( $ ) => {
	/**
	*  new_map
	*
	*  This function will render a Google Map onto the selected jQuery element
	*
	*  @type	function
	*  @date	8/11/2013
	*  @since	4.3.0
	*
	*  @param	$el (jQuery element)
	*  @return	n/a
	*/
	function acNewMap( $el ) {
		// var
		const $markers = $el.find( '.marker' );

		// vars
		const args = {
			zoom: 6,
			center: new google.maps.LatLng( 0, 0 ),
			mapTypeId: google.maps.MapTypeId.ROADMAP,
			zoomControl: true,
			scaleControl: true,
			streetViewControl: false,
			rotateControl: false,
			fullscreenControl: false,
			mapTypeControl: false,
			styles: [
				{
					featureType: 'administrative',
					elementType: 'labels.text.fill',
					stylers: [
						{
							color: '#9bb3b7',
						},
					],
				},
				{
					featureType: 'administrative',
					elementType: 'labels.text.stroke',
					stylers: [
						{
							color: '#ffffff',
						},
					],
				},
				{
					featureType: 'landscape',
					stylers: [
						{
							color: '#f7f7f7',
						},
					],
				},
				{
					featureType: 'poi',
					stylers: [
						{
							visibility: 'off',
						},
					],
				},
				{
					featureType: 'road',
					stylers: [
						{
							saturation: -100,
						},
						{
							lightness: 45,
						},
					],
				},
				{
					featureType: 'road.arterial',
					elementType: 'labels.icon',
					stylers: [
						{
							visibility: 'off',
						},
					],
				},
				{
					featureType: 'road.highway',
					stylers: [
						{
							visibility: 'simplified',
						},
					],
				},
				{
					featureType: 'transit',
					stylers: [
						{
							visibility: 'off',
						},
					],
				},
				{
					featureType: 'water',
					stylers: [
						{
							color: '#ededed',
						},
						{
							visibility: 'on',
						},
					],
				},
			],
		};

		// create map
		const map = new google.maps.Map( $el[ 0 ], args );

		// add a markers reference
		map.markers = [];

		// add markers
		$markers.each( function() {
			map.markers.push( acAddMarker( $( this ), map ) );
		} );

		// center map
		acCenterMap( map );
	}

	/**
	*  add_marker
	*
	*  This function will add a marker to the selected Google Map
	*
	*  @type	function
	*  @date	8/11/2013
	*  @since	4.3.0
	*
	*  @param	$marker (jQuery element)
	*  @param	map (Google Map object)
	*  @return	n/a
	*/

	function acAddMarker( $marker, map ) {
		const latlng = new google.maps.LatLng( $marker.data( 'lat' ), $marker.data( 'lng' ) );
		const baseUrl = document.location.origin;
		const icon = {
			url: baseUrl + '/wp-content/themes/qala-theme/assets/images/icons/location.svg',
			origin: new google.maps.Point( 0, 0 ),
			anchor: new google.maps.Point( 29 / 2, 40 ),
			scaledSize: new google.maps.Size( 29, 40 ),
		};

		// create marker
		const marker = new google.maps.Marker( {
			position: latlng,
			map: map,
			icon: icon,
		} );

		// if marker contains HTML, add it to an infoWindow
		if ( $marker.html() ) {
			// Show/hide correct infowindow.
			google.maps.event.addListener( marker, 'click', function() {
				const position = this.getPosition();
				const latandlng = '#info' + position.lat() + '' + position.lng();
				const elemID = latandlng.split( '.' ).join( '' );
				$( '.acf-map__wrap .map-info-window' ).addClass( 'hidden' );
				$( elemID ).removeClass( 'hidden' );
			} );
		}

		return marker;
	}

	/**
	*  center_map
	*
	*  This function will center the map, showing all markers attached to this map
	*
	*  @type	function
	*  @date	8/11/2013
	*  @since	4.3.0
	*
	*  @param	map (Google Map object)
	*  @return	n/a
	*/
	function acCenterMap( map ) {
		var bounds = new google.maps.LatLngBounds();
    map.markers.forEach( ( marker ) => {
			bounds.extend({
				lat: marker.position.lat(),
				lng: marker.position.lng()
			});
    });

		if ( map.markers.length == 1 ) {
			map.setCenter( bounds.getCenter() );
		} else {
			map.fitBounds( bounds );
		}
	}

	/**
	*  document ready
	*
	*  This function will render each map when the document is ready (page has loaded)
	*
	*  @type	function
	*  @date	8/11/2013
	*  @since	5.0.0
	*
	*  @param	n/a
	*  @return	n/a
	*/
	$( document ).ready( () => {
		$( '.acf-map' ).each( function() {
			// create map
			acNewMap( $( this ) );
		} );

		$( '.map-info-window .close' ).on( 'click', function() {
			$( this ).closest( '.map-info-window' ).addClass( 'hidden' );
		} );
	} );
} );
